'use client'

import HowItWorksOverlay from '@/components/HowItWorksOverlay/HowItWorksOverlay.tsx'
import { ConsentType } from '@/helpers/consent'

export default function EarnDialogContentClient() {
  return (
    <HowItWorksOverlay
      type={ConsentType.Earn}
      title="How Earn Works"
      steps={[
        {
          title: 'Deposit in a Morpho Vault',
          description:
            'Earn yield by depositing an asset into a curated vault. Each vault has unique risk parameters and allocation rules. Creating a vault is permissionless, so users should assess a vault’s curator and risk exposure before depositing.'
        },
        {
          title: 'Assets are supplied to Morpho Markets',
          description:
            'A Morpho Vault can only allocate deposits to Morpho Markets whitelisted by the curator. Depositors in the vault are exposed to risks related to each market, including the collateral asset, liquidation LTV, and oracles.'
        },
        {
          title: 'Earn yield from borrowers',
          description:
            'Vaults generate a yield from over-collateralized lending. Borrowers deposit collateral and borrow assets supplied to Morpho Markets, paying interest to the vault.'
        }
      ]}
      terms={
        <>
          {
            'Morpho is committed to industry-leading security practices, but there are still risks associated with '
          }
          <a
            href="https://docs.morpho.org/morpho/concepts/risk-documentation"
            target="_blank"
            rel="noreferrer"
          >
            Morpho
          </a>
          {' and '}
          <a
            href="https://docs.morpho.org/morpho-vaults/concepts/risk-documentation"
            target="_blank"
            rel="noreferrer"
          >
            {'Morpho Vaults'}
          </a>
          .
        </>
      }
    />
  )
}
